
import { FC, HTMLAttributes, useEffect } from "react";
import { useStyles } from "./VoucherInventoryDetail.style";
import { useNavigate, useParams } from "react-router-dom";
import { useEpayVoucherByBundleId, useListItemsByVoucherBundle } from "../../../hooks/resolvers/shop/useShopQuery";
import AppBar from "../AppBar/AppBar";
import { Icon } from "../../core/Icon/Icon";
import { HistoryGaming } from "../../../models/historyGaming";
import { PageRoutes } from "../../../constants/historyGaming";
import { Voucheritem } from "./VoucherItem";
import { Typography, TypographyVariant } from "@onmo/ui";

export const VoucherInventoryDetail: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { bundleId } = useParams<{ bundleId: string }>();
  const bundleDetail = useEpayVoucherByBundleId(bundleId);
  const { itemList, loading } = useListItemsByVoucherBundle(bundleId);

  useEffect(() => {
    if (!loading && !itemList) {
      navigate(`${PageRoutes.Store}`);
    }
  }, [loading, itemList, navigate]);

  const handleItemClick = (itemId: string) => {
    navigate(`${PageRoutes.VoucherItemDetail}/${bundleId}/${itemId}`);
  };

  return (
    <div className={classes.root}>
      <AppBar
        leftItems={
          <Icon
            name="icon-bold-arrow-left-3"
            onClick={() => HistoryGaming.back(navigate)}
            data-testid="back-icon"
          />
        }
        centerItems={
          <Typography
            variant={TypographyVariant.BodyB4Medium}
            data-testid="bundle-title"
          >
            {bundleDetail?.title}
          </Typography>
        }
      />
      {itemList && itemList.length > 0 && (
        <div className={classes.content}>
          {itemList.map((item, idx) => (
            <Voucheritem
              key={item.id + idx}
              item={item}
              onClick={() => handleItemClick(item.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}